import { Switch } from 'react-native'

export const Toggle = ({ value, setFieldValue, fieldName, disabled = false }) => {
  const onChange = (val) => {
    if (fieldName && setFieldValue) {
      setFieldValue(fieldName, val)
    }
  }
  return <Switch value={value} onValueChange={onChange} trackColor={{ false: '#1386B080', true: '#1386B080' }} disabled={disabled}/>
}
